export enum EditMode {
  Update = 'update',
  Create = 'create',
}
